module.exports = __webpack_public_path__ + "communication-48-x-48.a69990e65b01c96e54f0.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/communication/webfont/communication-48-x-48.eot
// module id = ../../../../../src/assets/fonts/line-icons-pro/communication/webfont/communication-48-x-48.eot
// module chunks = styles